export default "__VITE_ASSET__CUTZrdpU__"